import { render, staticRenderFns } from "./CreativesReportModal.vue?vue&type=template&id=0e84f80a&scoped=true"
import script from "./CreativesReportModal.vue?vue&type=script&lang=js"
export * from "./CreativesReportModal.vue?vue&type=script&lang=js"
import style0 from "./CreativesReportModal.vue?vue&type=style&index=0&id=0e84f80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e84f80a",
  null
  
)

export default component.exports